import { combineReducers } from '@reduxjs/toolkit'

import loginReducer from './login'
import tenantsReducer from './tenants'
import adminReducer from './admins'
import themeReducer from './theme'
import currencyReducer from './currencies'
import fetchReducer from './fetchData'
import tenantsFetchDataReducer from './tenantsFetchData'
import credentialsReducer from './tenantcredentials'
import tenantUsersReducer from './tenantUsers'
import adminUserReducer from './adminUser'
import tenantAffiliatesReducer from './tenantAffiliates'
import tenantCasinoReducer from './tenantCasino'
import superAdminCasinoManagementReducer from './superAdminCasinoManagement'
import superAdminTransactionReducer from './superAdminTransactions'
import tenantTransactionReducer from './tenantTransactions'
import bonusReducer from './bonus'
import superAdminSettingsReducer from './superAdminSettings'
import dashboardReducer from './dashboard'
import wageringTemplateReducer from './wageringTemplate'
import emailTemplateReducer from './emailTemplate'
import languageReducer from './languages'
import paymentReducer from './payment'
import authReducer from './auth'
import bannedPlayerReducer from './bannedPlayer'
import tournamentReducer from './tournaments'
import RGModuleReducer from './rgModule'
import AmlModuleReducer from './amlModule'
import licenseManagementReducer from './licenseManagement'
import redirectionManagementReducer from './redirectionManagement'
import uiConfigReducer from './uiConfig'

const appReducer = combineReducers({
  login: loginReducer,
  tenants: tenantsReducer,
  admins: adminReducer,
  theme: themeReducer,
  currencies: currencyReducer,
  tenantsFetch: tenantsFetchDataReducer,
  fetch: fetchReducer,
  tenantcredentials: credentialsReducer,
  tenantUsers: tenantUsersReducer,
  adminUser: adminUserReducer,
  tenantAffiliate: tenantAffiliatesReducer,
  tenantCasino: tenantCasinoReducer,
  superAdminCasino: superAdminCasinoManagementReducer,
  superAdminTransactions: superAdminTransactionReducer,
  tenantTransactions: tenantTransactionReducer,
  bonus: bonusReducer,
  superAdminSettings: superAdminSettingsReducer,
  dashboard: dashboardReducer,
  wageringTemplate: wageringTemplateReducer,
  emailTemplate: emailTemplateReducer,
  languages: languageReducer,
  payment: paymentReducer,
  auth: authReducer,
  tournaments: tournamentReducer,
  RGModule: RGModuleReducer,
  amlModule: AmlModuleReducer,
  bannedPlayer: bannedPlayerReducer,
  licenseManagement: licenseManagementReducer,
  redirectionManagement: redirectionManagementReducer,
  uiConfig: uiConfigReducer
})

export const resetState = () => ({
  type: 'resetState'
})

const rootReducer = (state, action) => {
  // This logic handles a specific case of resetting the application state when a 'resetState' action is triggered.
  //
  // It preserves the 'uiConfig' portion of the state while delegating other
  // state management to 'appReducer'.
  if (action.type === 'resetState') {
    const { uiConfig } = state || {}
    return {
      ...appReducer(undefined, action),
      uiConfig
    }
  }

  return appReducer(state, action)
}

export default rootReducer
